
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Operation } from '../operation/operation';
import { Revision } from './revision';
import { Apollo } from 'apollo-angular';

const RevisionsQuery = require('./gql/revisions.query.gql');
const RevisionQuery = require('./gql/revision.query.gql');
const createRevisionMutation = require('./gql/create-revision.mutation.gql');
const updateRevisionMutation = require('./gql/update-revision.mutation.gql');
const duplicateRevisionMutation = require('./gql/duplicate-revision.mutation.gql');
const deleteRevisionMutation = require('./gql/delete-revision.mutation.gql');

/**
 * Service to manage revisions
 */
@Injectable()
export class RevisionService {

  constructor(private apollo: Apollo) { }

  revisions(operation_id: string, status: string = null, limit: number = null): Observable<Operation> {
    return this.apollo
      .query({
        query: RevisionsQuery,
        variables: {
          operation_id,
          status,
          limit
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => new Operation(result.data['operation'])));
  }

  revision(operation_id: string, id: string): Observable<Operation> {
    return this.apollo
      .query({
        query: RevisionQuery,
        variables: {
          operation_id,
          id
        }
      }).pipe(
      map(result => new Operation(result.data['operation'])));
  }

  create(operation_id: string): Observable<Revision> {
    return this.apollo
      .mutate({
        mutation: createRevisionMutation,
        variables: {
          operation_id
        }
      }).pipe(
      map(result => new Revision(result.data['createRevision'])));
  }

  update(operation_id: string, id: string, status: string): Observable<Revision> {
    return this.apollo
      .mutate({
        mutation: updateRevisionMutation,
        variables: {
          operation_id,
          id,
          status
        }
      }).pipe(
      map(result => new Revision(result.data['updateRevision'])));
  }

  duplicate(operation_id: string, id: string, status: string): Observable<Revision> {
    return this.apollo
      .mutate({
        mutation: duplicateRevisionMutation,
        variables: {
          operation_id,
          id,
          status
        }
      }).pipe(
      map(result => new Revision(result.data['duplicateRevision'])));
  }

  delete(operation_id: string, id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteRevisionMutation,
        variables: {
          operation_id,
          id
        }
      }).pipe(
      map(result => result.data['deleteRevision']));
  }
}